import { render, staticRenderFns } from "./CollapseStudent.vue?vue&type=template&id=93b5ba7c&"
import script from "./CollapseStudent.vue?vue&type=script&lang=js&"
export * from "./CollapseStudent.vue?vue&type=script&lang=js&"
import style0 from "./CollapseStudent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports